export default __webpack_public_path__ + "static/media/redflagdeals.fb2543ba.png";